"use strict";
/*!
 *
 *  top.js
 *
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var object_fit_images_1 = __importDefault(require("object-fit-images"));
var default_1 = /** @class */ (function () {
    function default_1() {
        if ($('main').is('.tp-Main')) {
            this.hero();
            this.bnrs();
            this.scrollAnim();
        }
        ;
    }
    default_1.prototype.hero = function () {
        var $elem = $('#TopHeroSlider');
        if ($elem.length) {
            var len_1 = $elem.children('.tp-Hero_Slider_Item').length;
            $elem.on('lazyLoaded', function () {
                if (--len_1 > 0)
                    return false;
                $elem.attr('aria-hidden', 'false');
                (0, object_fit_images_1.default)('img.sw-ObjectFit', { watchMQ: true });
            });
            $elem.slick({
                lazyLoad: 'progressive',
                arrows: false,
                infinite: true,
                dots: true,
                autoplay: true,
                autoplaySpeed: 3000,
                speed: 1000,
                centerMode: true,
                slidesToShow: 1,
                variableWidth: true,
                appendDots: $('.tp-Hero_Dots')
            });
            // $elem.slick({
            // 	lazyLoad: 'progressive',
            // 	arrows: false,
            // 	dots: true,
            // 	fade: true,
            // 	autoplay: true,
            // 	autoplaySpeed: 3000,
            // 	speed: 2000,
            // 	appendDots: $('.tp-Hero_Dots')
            // })
        }
        ;
    };
    default_1.prototype.bnrs = function () {
        if ($('#TopBnrsSlider').length) {
            $('#TopBnrsSlider').slick({
                arrows: true,
                centerMode: true,
                centerPadding: '0px',
                variableWidth: true,
                mobileFirst: true,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                            infinite: true
                        }
                    },
                    {
                        breakpoint: 769,
                        settings: 'unslick'
                    }
                ]
            });
            if (util.viewport !== 'phone') {
                $('#TopBnrsSlider').addClass('-initialized');
            }
            ;
            $(window).on('viewportChanged', function () {
                if (util.viewport === 'phone') {
                    $('#TopBnrsSlider').slick('init');
                }
                else {
                    $('#TopBnrsSlider').addClass('-initialized');
                }
                ;
            });
        }
        ;
    };
    default_1.prototype.scrollAnim = function () {
        var _this = this;
        if ($('.c-Contact').length) {
            $('.c-Contact').find('.c-LeadTitle').addClass('sw-SA -move-t');
            $('.c-Contact').find('.c-Grid_Row').addClass('sw-SA -move-t-children');
        }
        ;
        var targets = this.getTargets();
        var max = targets.length;
        $(window).on('scroll.scrollAnim', function (e) {
            var _top = $(e.currentTarget).scrollTop();
            targets.forEach(function (val) {
                if (!$(val.elem).is('.-run') && (_top + (util.wh / 2) + (util.wh / 3)) > val.top) {
                    $(val.elem).addClass('-run');
                    max--;
                }
                ;
                if (max === 0) {
                    $(window).off('.scrollAnim');
                }
                ;
            });
        });
        $(window).on('resize.scrollAnim', function () {
            targets = _this.getTargets();
        });
        $(window).trigger('scroll.scrollAnim');
    };
    default_1.prototype.getTargets = function () {
        var arr = [];
        $('.sw-SA').each(function (i, elem) {
            arr.push({
                top: $(elem).offset().top,
                elem: elem
            });
        });
        return arr;
    };
    ;
    return default_1;
}());
exports.default = default_1;
;
